import { AuthRepository } from "../repositories/AuthRepository";
import { AuthResultEntity, LoginCredentials } from "../entities/AuthResult";

/**
 * Admin Login Use Case
 * Handles admin login with role verification
 */
export class AdminLoginUseCase {
  constructor(private authRepository: AuthRepository) {}

  /**
   * Execute admin login
   * @param credentials - Admin credentials
   * @returns Authentication result
   * @throws Error if user is not an admin
   */
  async execute(credentials: LoginCredentials): Promise<AuthResultEntity> {
    // Validate credentials
    if (!credentials.email || !credentials.password) {
      throw new Error("Email and password are required");
    }

    if (!this.isValidEmail(credentials.email)) {
      throw new Error("Invalid email format");
    }

    // Perform admin login through repository
    const result = await this.authRepository.adminLogin(credentials);

    // Additional admin-specific business logic can be added here
    // For example, logging admin access, checking admin permissions, etc.

    return result;
  }

  /**
   * Validate email format
   */
  private isValidEmail(email: string): boolean {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }
}
